// Libs
import classNames from 'classnames/bind';
import { Outlet } from 'react-router-dom';
// Components, Layouts, Pages
import { Box } from '@mui/material';
// Others
// Styles, images, icons
import styles from './Inventories.module.scss';

type Props = {};

const cx = classNames.bind(styles);

const Inventories = (props: Props) => {
  //#region Destructuring Props
  const {} = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <Box component={'div'} className={cx('container')} id='inventoriesPage'>
      <Outlet />
    </Box>
  );
};

export default Inventories;
